import AOS from "aos";
import lozad from "lozad";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, appendCaptchaASP, replaceSvgImages } from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
	replaceSvgImages();
	FAQ();
	buttonToTop();
	CounterUps();
	TabNav();
	ToggleItem();
	ScrollAbout();
	ScrollProject();
});

/*==================== Aos Init ====================*/
setTimeout(() => {
	AOS.init({
		offset: 100,
	});
}, 1000);

/*==================== FAQ =================*/
function FAQ() {
	$(".faq-full-content .main-faq:nth-child(1)").addClass("active-faq");
	$(".faq-full-content .main-faq:nth-child(1) .heading-faq").addClass("active");
	$(".faq-full-content .main-faq:nth-child(1) .content-faq").slideDown();
	$(".heading-faq").on("click", function () {
		var $mainFaq = $(this).closest(".main-faq");
		if ($(this).hasClass("active")) {
			$(this).siblings(".content-faq").slideUp();
			$(this).removeClass("active");
			$mainFaq.removeClass("active-faq");
		} else {
			$(".heading-faq").removeClass("active");
			$(".content-faq").slideUp();
			$(".main-faq").removeClass("active-faq");

			$(this).siblings(".content-faq").slideToggle();
			$(this).toggleClass("active");
			$mainFaq.addClass("active-faq");
		}
	});
}

function TabNav() {
	$('.tab-group').each(function () {
		const $group = $(this);
		const $section = $group.closest('section');
		const $tabs = $group.find('.list-tab li');
		const $contents = $section.find('.tab-content');
		$contents.hide().removeClass('active');
		$contents.first().show().addClass('active');
		$tabs.removeClass('active').first().addClass('active');

		$tabs.on('click', function (e) {
			e.preventDefault();

			let target = $(this).find('a').attr('href') || $(this).find('a').data('target');
			if (!target) return;

			if (!target.startsWith('#')) {
				target = '#' + target;
			}

			$tabs.removeClass('active');
			$(this).addClass('active');

			$contents.hide().removeClass('active');
			$(target).show().addClass('active').fadeIn(0);
		});
	});
}

function ToggleItem() {
	jQuery(document).ready(function ($) {

		const $items = $('.list-career .item-toggle');

		// Active item đầu tiên
		$items.first().addClass('active');
		$items.first().find('.content').slideDown(0);

		// Toggle khi click
		$('.list-career').on('click', '.item-toggle .title', function () {
			const $parent = $(this).closest('.item-toggle');

			// Nếu muốn dạng accordion (mở cái này đóng cái khác)
			if (!$parent.hasClass('active')) {
				$items.removeClass('active').find('.content').slideUp(200);
			}

			$parent.toggleClass('active');
			$parent.find('.content').slideToggle(200);
		});

	});

}

function ScrollProject() {
	$('.single-portfolio-menu li a').click(function (e) {
		e.preventDefault();
		var linkTo = $(this).attr('href');

		$('html,body').animate({
			scrollTop:
				$(linkTo).offset().top - 150
		}, 350);
	});
}

function ScrollAbout() {
	$(document).ready(function () {
		$(".nav_scroll ul li a").on("click", function (e) {
			e.preventDefault();
			var target = $($(this).attr("href"));
			if (target.length) {
				$("html, body").animate(
					{
						scrollTop: target.offset().top - 110,
					},
					600
				);
			}
		});

		$(window).on("scroll", function () {
			var scrollPos = $(window).scrollTop();

			$("section[id]").each(function () {
				var top = $(this).offset().top - 150;
				var bottom = top + $(this).outerHeight();

				if (scrollPos >= top && scrollPos < bottom) {
					var id = $(this).attr("id");
					$(".nav_scroll li").removeClass("active");
					$('.nav_scroll ul li a[href="#' + id + '"]')
						.parent("li")
						.addClass("active");
				}
			});
		});
	});
}

function CounterUps() {
	$(document).ready(function () {
		function animateCountUp(el) {
			const $el = $(el);
			const $suffix = $el.find('.suffix'); // lấy riêng suffix
			const suffixText = $suffix.length ? $suffix.text() : ''; // + hoặc % hoặc bỏ trống

			let rawNumber = $el.data("number").toString().replace(/[.,\s]/g, "");
			const targetNumber = parseInt(rawNumber, 10);
			const duration = 1500;
			const increment = Math.ceil(targetNumber / (duration / 16));
			let currentNumber = 0;

			const timer = setInterval(function () {
				currentNumber += increment;
				if (currentNumber >= targetNumber) {
					currentNumber = targetNumber;
					clearInterval(timer);
				}

				// Chỉ cập nhật phần số, giữ nguyên suffix
				$el.contents().filter(function () {
					return this.nodeType === 3; // text node
				}).first().replaceWith(currentNumber.toLocaleString("vi-VN"));

				// Hoặc cách đơn giản hơn: chỉ thay đổi text trước suffix
				// $el.html(currentNumber.toLocaleString("vi-VN") + '<span class="suffix">' + suffixText + '</span>');
			}, 16);
		}

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					animateCountUp(entry.target);
					obs.unobserve(entry.target);
				}
			});
		}, { threshold: 0.6 });

		$(".countup").each(function () {
			observer.observe(this);
		});
	});

}





/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
